<template>
 <section class="newTable" >
  <table class="table datatable table-striped area-list-datatable" id="FullTargetCustomTable" >
    <thead>
      <tr>
        <th width="120">
          <div class="checkbox checkbox-inline mr-0">
            <input 
            @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
            type="checkbox" 
            name="check-all" 
            id="check-all" 
            value="1" 
            v-model="checkAll">
            <label for="check-all"></label>
          </div>
          <span>#</span>
        </th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('name')"
        >姓名</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'policy_no' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('policy_no')"
        >保單號碼</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'lpsdt' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('lpsdt')"
        >滿期日</th>
        <th
        width="*"
        >滿期金額</th>
        <th
        width="*"
        >滿期保單狀態</th>
        <th
        width="*"
        >聯繫單列印</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'visit_dateline' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('visit_dateline')"
        >聯繫拜訪期限</th>
         <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'accept_date' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('accept_date')"
        >拜訪日期</th>
        <th
        width="148"
        >未拜訪說明</th>
      </tr>
    </thead>
    <tbody class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableDataBackup" :key="`FullTargetCustomTable-table-td-${did}`">
          <td width="120">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                type="checkbox"
                name="`td-item[]`"
                :id="`PrecisionMarketingDataTable-check-${did}`"
                :value="d.id"
                v-model="selection"
                :disabled="d.id === ''"
                @change="$emit('update', selection)">
                <label :for="`PrecisionMarketingDataTable-check-${did}`"></label>
              </div>
              
              <span>
              <span class="no">{{did + 1}}</span>
              <span class="info text-center">
               <level :lv="Number(d.vip_lv)" />
                <avatar :gender="Number(d.sex)" :size="20" />
              </span>
              </span>
            </div>
          </td>
          <td width="*">
            <Tooltip  :position="did < 3 ?'bottom':'top'" :name="d.name">
              <a v-if="d.is_exist" @click.prevent="routerToCust(d.id, d.name)" class="link text-underline">{{d.name | getMaskName}}</a>
              <a v-else >{{d.name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td width="*">{{d.policy_no}}</td>
          <td width="*">
            <div class="date">{{d.lpsdt| dateFormat}}</div>
          </td>
          <td width="*">{{d.curr}}<br>{{d.lpsamt| numberFormat}}元</td>
          <td width="*">
            <span v-if="d.id == d.isdno && d.id == d.bnf_idno && d.visit_type == 'A'">被、受、<br><b><span style="color:red;">指定拜訪</span></b></span>
            <span v-else-if="d.id == d.isdno && d.id == d.bnf_idno">被、受</span>
            <span v-else-if="d.id== d.isdno && d.visit_type == 'A'">被、<b><span style="color:red;">指定拜訪</span></b></span>
            <span v-else-if="d.id== d.bnf_idno && d.visit_type == 'A'">受、<b><span style="color:red;">指定拜訪</span></b></span>
            <span v-else-if="d.id == d.isdno">被</span>
            <span v-else-if="d.id == d.bnf_idno">受</span>
            <span v-else-if="d.visit_type == 'A'"><b><span style="color:red;">指定拜訪</span></b></span>
          </td>
          <td width="*">
            <span v-if="d.not_show == '1'">— —</span>
            <span v-else-if="d.not_show == '0' && d.accept_date">紙本列印</span>
            <span v-else-if="d.not_show == '0' && !d.isshow">紙本列印</span>
            <a v-else class="text-green text-underline pointer-cursor" @click.prevent="print(d.policy_no, d.id)">紙本列印</a>
          </td>
          <td width="*">
            <span v-if="d.not_show == '1'">— —</span>
            <span v-else>{{d.visit_dateline| dateFormat}}</span>
            </td>
          <td width="*">
            <span v-if="d.not_show == '1'">— —</span>
            <span v-else>{{d.accept_date | dateFormat}}</span>
            </td>
          <td :width="iPadWidth">
            <span v-if="d.not_show == '1'">— —</span>
            <span v-else-if="d.not_show == '0'">
            <button type="button"
            v-if="!d.accept_date"
            class="btn btn-primary" 
            @click="$emit('NonVisit-Reason', d)"
            v-html="'<span style=\'font-size:1.25rem\'>填寫<span>'"></button>
            <button type="button"
            v-else
            class="btn btn-primary"
            :disabled="true"
            ><span style='font-size:1.25rem'>填寫</span></button></span>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>
              無客戶名單資料
            </h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
    </tbody>
  </table>
    <form v-show="false" name="form_A" :action="postUrl" method="post" target="_blank" accept-charset="big5" onsubmit="document.charset = 'big5'">

    <span>聯繫單編號 :  </span>
    <input name='VISIT_NO'   :value="this.dtData.visit_no" ><br>

    <span>保單號碼 :  </span>
    <input name='PLCNO'   :value="this.dtData.plcno"><br>

    <span>要保人姓名 :  </span>
    <input name='CS_NAME' :value="this.dtData.apcnm"><br>

    <span>同仁姓名 :  </span>
    <input name='CEEMPNM' :value="this.dtData.CEEMPNM"><br>

    <span>滿期日 :  </span>
    <input name='DUEDT' :value="this.dtData.lpsdt? dateFormat(this.dtData.lpsdt): ''"><br>

      <span>拜訪期限 :  </span>
    <input name='VISIT_DLINE' :value="this.dtData.visit_dateline? dateFormat(this.dtData.visit_dateline): ''"><br>

    <span>保單名稱 :  </span>
    <input name='PLAN_NAME' :value="this.dtData.plan_name"><br>

    <span>保險金額 :  </span>
    <input name='CESUMI' :value="this.dtData.cesumi? numFormat(this.dtData.cesumi) : ''"><br>

    <span>繳費年期 :  </span>
    <input name='CEPRD' :value="this.dtData.ceprd"><br>

    <span>滿期金額 :  </span>
    <input name='DUEMO' :value="this.dtData.lpsamt"><br>

    <span>滿期受益人1 :  </span>
    <input name='BNFNM' :value="this.dtData.bnf_name"><br>

    <span>滿期受益人人數:  </span>
    <input name='BNFCNT' :value="this.dtData.bnf_cnt"><br>

    <span>保單幣別 :  </span>
    <input name='CURR' :value="this.dtData.plan_curr"><br>

    <span>幣別中文 :  </span>
    <input name='CURR_CH' :value="this.dtData.CURR_CH"><br>

    <button type="submit" id="sendSubmit">點擊送出</button>

  </form>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import { getFullPlcInfo, updatePrintDate, showFullPlcPDF } from "@/service";
import moment from "moment";
import Tooltip from "@/desktop/components/ToolTip";
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "FullTargetCustomTable",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      dtData: [],
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth,
      postUrl: "",
      today: "",
      sendUrl: "crms/ProReport/servlet/servlets.Efflux_ContactForm" //報表路徑
    };
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach((data) => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    dateFormat(val) {
      // 轉換為民國
      if (val) {
        let dataAry = val.split("-");
        dataAry[0] = dataAry[0] * 1 - 1911 + "";
        return dataAry.join("-");
      }
      return "";
    },
    numFormat(num = 0) {
      // 組合保額 and 保額單位
      let number = Number(num);
      number = number / 10000;
      return number;
    },
    async print(policy_no, id) {
      let newWindow;
      if (!this.isBox) {
        newWindow = window.open("/crm/assets/common/ajax-loader.gif");
      }
      
      const result = await getFullPlcInfo(
        this.$store.state.userInfo.id,
        policy_no
      );
      if (result.header && result.header.status == "200") {
        this.dtData = result.body.lists;
        this.dtData = this.dtData[0];
        if (this.dtData.plan_curr == "NTD") {
          this.dtData.CURR_CH = "新台幣";
        } else if (this.dtData.plan_curr == "USD") {
          this.dtData.CURR_CH = "美元";
        } else if (this.dtData.plan_curr == "AUD") {
          this.dtData.CURR_CH = "澳幣";
        } else if (this.dtData.plan_curr == "NZD") {
          this.dtData.CURR_CH = "紐幣";
        } else if (this.dtData.plan_curr == "CNY") {
          this.dtData.CURR_CH = "人民幣";
        } else {
          this.dtData.CURR_CH = "新台幣";
        }
        this.dtData.CEEMPNM = this.$store.state.userInfo.name;
      }
      this.registerHanlink(); // for 難字更新

      await updatePrintDate(this.$store.state.userInfo.id, policy_no, id);
      
      const pdfResult = await showFullPlcPDF(
        this.$store.state.userInfo.id,
        policy_no,
        this.$store.state.userInfo.name,
      );

      if (this.isBox) {
        this.boxSendBase64PdfData(new Uint8Array(pdfResult.file));
      } else { 
        let file = new Blob([new Uint8Array(pdfResult.file)], {
          type: "application/pdf"
        });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, "post.pdf");
        } else {
          newWindow.location = URL.createObjectURL(file);
        }
      }
    },
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }
      switch (fieldName) {
        case "birthday":
        case "pay_date":
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.dateCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
      }
    },
    dateCompareFun(sortOrder, property) {
      let vm = this;
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.today = moment().format("YYYY-MM-DD");
      this.tableDataBackup = this.tableData.map((ele) => {
        return ele;
      });
      this.tableDataBackup.forEach((item) => {
        item.money = this.formatAmtForCathay(item.lpsamt);
        //過了滿期日則不顯示紙本列印連結
        if (moment(item.lpsdt).isBefore(this.today)) {
          item.isshow = false;
        } else {
          item.isshow = true;
        }
      });
      this.allIdData = this.tableData.map((ele) => {
        return ele.id;
      });
      this.order.fieldName = "name";
      this.order.asc = true;
      this.registerHanlink(); // for 難字更新
    },
    formatAmtForCathay(value) {
      var currHtml = ``;
      if (typeof value === "number") {
        value = value.toFixed(0);
        let replaceRegex = /\B(?=(\d{3})+(?!\d))/g;
        if (value <= 9999) {
          return `${value.toString().replace(replaceRegex, ",")}元`;
        } else {
          let million = parseInt(value / 10000);
          let dollar = value % 10000;

          var amtHtml = ``;
          amtHtml += `${million.toString().replace(replaceRegex, ",")}萬`;
          amtHtml += `${dollar.toString().replace(replaceRegex, ",")}元`;

          return `${amtHtml}`;
        }
      } else if (typeof value === "string") {
        if (value) {
          return `${value}`;
        } else {
          return `<div>--</div>`;
        }
      } else {
        return `<div>--</div>`;
      }
    }
  },
  mounted() {
    let href = window.location.href;
    if (href.includes("://mycrm")) {
      // 正式環境
      this.postUrl =
        "https://w3.cathaylife.com.tw/crms/ProReport/servlet/servlets.Efflux_ContactForm";
    } else if (href.includes("://smycrm")) {
      // 平測環境
      this.postUrl =
        "https://sw3.cathaylife.com.tw/crms/ProReport/servlet/servlets.Efflux_ContactForm";
    } else {
      // local & 測試環境
      this.postUrl =
        "https://tw3.cathaylife.com.tw/crms/ProReport/servlet/servlets.Efflux_ContactForm";
    }

    this.currentWidth =
      this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1);
    if (!is_iPad) {
      this.iPadWidth = "131";
    } else {
      this.iPadWidth = "148";
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
